export default __webpack_public_path__ + "static/media/button-dont-example-2.afda9360.svg";